import Img1 from '../../images/Car.svg';
import Img2 from '../../images/Media.svg';
import Img3 from '../../images/CarRepair.svg';
import Img4 from '../../images/Card.svg';
import Img5 from '../../images/Contact.svg';
import Img6 from '../../images/CarTick.svg';

export const BenData = [
  {
    img: Img2,
    h1: '5 Star Rated',
    Ptag: 'The pride we take into our customer service is spoken through hundreds of positive reviews on platforms like TrustPilot and Facebook from customers just like yourself.',
  },
  {
    img: Img3,
    h1: 'Part Exchange and Finance Facilities',
    Ptag: 'Most customers prefer the "no hassle" way of just exchanging cars, keys and documents and driving away in their new car! We offer accurate market value for any potential part exchange and always try to achieve the best value for our customers.',
  },

  {
    img: Img3,
    h1: 'H.P.I',
    Ptag: 'Every vehicle we supply has been checked through H.P.I giving you peace of mind that your next car has not been previously ” written off ” by an insurance company, is not on the Stolen Register, is not subject to a Finance Agreement etc. This also checks that all the data held for the car matches with the data held at DVLA. We would never supply a car that is subject to any of the above conditions. Remember, a car advertised as ” Cat C ” doesn’t mean it has a catalyctic converter – it means it has been written off in the past and our advice would be to ” steer clear ” !!',
  },

  {
    img: Img1,
    h1: 'Nationwide Delivery',
    Ptag: 'We can deliver your vehicle nationwide, or even further afield, at very competitive rates ! Our professional drivers can deliver to your home or work at your convenience. This option saves you time and fuel costs and let’s somebody else take the strain ! It’s a nice feeling having your new car delivered toYOU! Ask for a quote today.',
  },
  {
    img: Img4,
    h1: 'Debit and Credit Cards',
    Ptag: 'We have the facility to accept all major debit and credit cards. This is the safest way of arranging payment either in person or over the ‘phone. It is simple and fast to use and secures your car with a holding deposit staright away ! There is no waiting for a cheque or a bank transfer to clear and gets you ” on the road ” smoothly and quickly. Some fees may apply. Ask for details.',
  },
  {
    img: Img5,
    h1: 'Opening Times',
    Ptag: 'We are open 7 days a week from 8 a.m until 8 p.m. We recognise in todays workplace that it may not be convenient to visit us within in these times. To meet our customers demands we are flexible and can arrange a meeting before or after these opening tmes by prior appointment. We can also arrange a visit to your home or work which may be more convenient, again by prior appointment. Just ask – we aim to please !',
  },
];
